var _style, _g, _g2, _rect, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLotMerger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508.5 291.9",
    style: {
      enableBackground: "new 0 0 508.5 291.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:#D1D3D4;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill:#D1D3D4;}\n\t.st3{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:12.0998,12.0998;}\n\t.st5{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:12.1054,12.1054;}\n\t.st6{enable-background:new    ;}\n\t.st7{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "60.7,48.8 0.3,48.8 0.3,109.3 0.3,169.7 0.3,230.2 0.3,290.7 60.7,290.7 121.2,290.7 121.2,230.2  121.2,169.7 121.2,109.3 121.2,48.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "181.7,48.8 121.2,48.8 121.2,109.3 121.2,169.7 121.2,230.2 121.2,290.7 181.7,290.7 242.1,290.7  242.1,230.2 242.1,169.7 242.1,109.3 242.1,48.8  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "326.2,48.8 265.8,48.8 265.8,109.3 265.8,169.7 265.8,230.2 265.8,290.7 326.2,290.7 386.7,290.7  386.7,230.2 386.7,169.7 386.7,109.3 386.7,48.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "271.8,48.8 265.8,48.8 265.8,54.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "265.8,66.9 265.8,109.3 265.8,169.7 265.8,230.2 265.8,278.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "265.8,284.7 265.8,290.7 271.8,290.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "283.9,290.7 326.2,290.7 374.7,290.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "380.7,290.7 386.7,290.7 386.7,284.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "386.7,272.6 386.7,230.2 386.7,169.7 386.7,109.3 386.7,60.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "386.7,54.8 386.7,48.8 380.7,48.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "368.6,48.8 326.2,48.8 277.8,48.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "447.2,48.8 386.7,48.8 386.7,109.3 386.7,169.7 386.7,230.2 386.7,290.7 447.2,290.7 507.7,290.7  507.7,230.2 507.7,169.7 507.7,109.3 507.7,48.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "392.7,48.8 386.7,48.8 386.7,54.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "386.7,66.9 386.7,109.3 386.7,169.7 386.7,230.2 386.7,278.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "386.7,284.7 386.7,290.7 392.7,290.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "404.8,290.7 447.2,290.7 495.6,290.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "501.7,290.7 507.7,290.7 507.7,284.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "507.7,272.6 507.7,230.2 507.7,169.7 507.7,109.3 507.7,60.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "507.7,54.8 507.7,48.8 501.7,48.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "489.6,48.8 447.2,48.8 398.8,48.8  "
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: 48.8,
    className: "st3",
    width: 241.9,
    height: 241.9
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9,5.1h1.8v7.1h3.6v1.5h-5.5V5.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1,8.4c0-1.3,0.2-2,0.7-2.5C51.4,5.2,52.2,5,53.4,5c1.3,0,2.1,0.3,2.7,1c0.4,0.5,0.6,1.2,0.6,2.4v2c0,1.3-0.2,2-0.7,2.5 c-0.6,0.6-1.3,0.9-2.5,0.9c-1.3,0-2.1-0.3-2.7-1c-0.4-0.5-0.6-1.2-0.6-2.4V8.4z M54.8,8.5c0-1.6-0.3-2.1-1.4-2.1 C52.3,6.4,52,7,52,8.5v1.7c0,1.6,0.3,2.1,1.4,2.1c1.1,0,1.4-0.5,1.4-2.1V8.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8,6.6h-2.3V5.1h6.4v1.5h-2.3v7.1h-1.8V6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7,12l-0.5,1.6h-2l3.1-8.6h1.8l3.1,8.6h-2L72.7,12H69.7z M71.2,7.2l-1.1,3.3h2.1L71.2,7.2z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M39.1,20.7h3.2v0.7h-2.5l-0.2,2.3c0.3-0.2,0.7-0.3,1.1-0.3c0.6,0,1.2,0.3,1.5,0.7c0.3,0.3,0.4,0.8,0.4,1.6 c0,0.7-0.1,1.3-0.5,1.6c-0.4,0.4-1,0.6-1.7,0.6c-1.2,0-1.8-0.5-2-1.5l0.8-0.1c0.1,0.6,0.5,0.9,1.2,0.9c0.8,0,1.3-0.5,1.3-1.5 c0-1.1-0.4-1.6-1.2-1.6c-0.4,0-0.8,0.1-1.1,0.4l-0.6-0.1L39.1,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M43.9,23.2c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8v2.1 c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V23.2z M47.1,23.3 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M49.3,20.7h0.8L49.6,23H49L49.3,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M52.9,22.8h0.9l1.1,1.8l1.1-1.8h0.9l-1.6,2.5l1.6,2.5H56l-1.2-1.9l-1.2,1.9h-0.9l1.6-2.6L52.9,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M61.6,21.5l-1.2,0.5l-0.3-0.7l1.7-0.8h0.6v7.1h-0.8V21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M65.2,23.2c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8v2.1 c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V23.2z M68.4,23.3 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M70.6,23.2c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8v2.1 c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V23.2z M73.8,23.3 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76,20.7h0.8L76.3,23h-0.7L76,20.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42,34.9h4.1v0.7h-3.3v2.5h2.8v0.7h-2.8V42H42V34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M47.8,40.5L47.3,42h-0.9l2.6-7.1h0.8l2.6,7.1h-0.9l-0.5-1.6H47.8z M49.4,36L48,39.8h2.7L49.4,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M54.2,42h-0.8v-7.1h2.4c0.8,0,1.3,0.1,1.7,0.5c0.4,0.4,0.5,0.8,0.5,1.5c0,1.2-0.5,1.8-1.5,2l1.6,3.2h-0.9 L55.8,39h-1.5V42z M55.9,38.3c0.9,0,1.4-0.4,1.4-1.3c0-0.9-0.5-1.3-1.5-1.3h-1.5v2.7H55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M61.3,37.3h4.4v0.6h-4.4V37.3z M61.3,38.9h4.4v0.6h-4.4V38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M69.9,37.9h0.6c0.8,0,1.3-0.5,1.3-1.2c0-0.8-0.4-1.2-1.1-1.2c-0.6,0-1,0.3-1.1,0.8l-0.7-0.1 c0.1-1,0.8-1.5,1.9-1.5c1.2,0,1.9,0.7,1.9,1.9c0,0.8-0.2,1.2-0.9,1.6c0.8,0.4,1.1,0.9,1.1,1.8c0,1.3-0.7,2-2.1,2 c-1.2,0-1.9-0.5-2-1.5l0.8-0.1c0.1,0.6,0.5,0.9,1.2,0.9c0.8,0,1.3-0.5,1.3-1.4s-0.6-1.5-1.4-1.5h-0.6V37.9z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.7,5.1h1.8v7.1h3.6v1.5h-5.5V5.1z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.9,8.4c0-1.3,0.2-2,0.7-2.5c0.6-0.6,1.3-0.9,2.5-0.9c1.3,0,2.1,0.3,2.7,1c0.4,0.5,0.6,1.2,0.6,2.4v2 c0,1.3-0.2,2-0.7,2.5c-0.6,0.6-1.3,0.9-2.5,0.9c-1.3,0-2.1-0.3-2.7-1c-0.4-0.5-0.6-1.2-0.6-2.4V8.4z M177.6,8.5 c0-1.6-0.3-2.1-1.4-2.1c-1.1,0-1.4,0.5-1.4,2.1v1.7c0,1.6,0.3,2.1,1.4,2.1c1.1,0,1.4-0.5,1.4-2.1V8.5z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.6,6.6h-2.3V5.1h6.4v1.5h-2.3v7.1h-1.8V6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.2,5.1h3.4c1,0,1.6,0.1,2,0.5c0.5,0.4,0.7,1,0.7,1.8c0,0.8-0.2,1.4-0.7,1.8c0.3,0.3,0.4,0.4,0.5,0.5 c0.2,0.4,0.3,0.9,0.3,1.5c0,0.9-0.3,1.5-0.8,2c-0.4,0.3-0.9,0.4-1.9,0.4h-3.5V5.1z M194.4,8.6c0.7,0,1-0.3,1-1c0-0.7-0.3-1-1-1H193 v2H194.4z M194.6,12.2c0.7,0,1-0.3,1-1.1c0-0.8-0.3-1.1-1-1.1H193v2.2H194.6z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M164.3,20.7h3.2v0.7H165l-0.2,2.3c0.3-0.2,0.7-0.3,1.1-0.3c0.6,0,1.2,0.3,1.5,0.7c0.3,0.3,0.4,0.8,0.4,1.6 c0,0.7-0.1,1.3-0.5,1.6c-0.4,0.4-0.9,0.6-1.7,0.6c-1.2,0-1.8-0.5-2-1.5l0.8-0.1c0.1,0.6,0.5,0.9,1.2,0.9c0.8,0,1.3-0.5,1.3-1.5 c0-1.1-0.4-1.6-1.2-1.6c-0.4,0-0.8,0.1-1.1,0.4l-0.6-0.1L164.3,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M169.2,23.2c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 v2.1c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V23.2z M172.3,23.3 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M174.6,20.7h0.8l-0.5,2.4h-0.7L174.6,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M178.1,22.8h0.9l1.1,1.8l1.1-1.8h0.9l-1.6,2.5l1.6,2.5h-0.9l-1.2-1.9l-1.2,1.9H178l1.6-2.6L178.1,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M186.8,21.5l-1.2,0.5l-0.3-0.7l1.7-0.8h0.6v7.1h-0.8V21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M190.5,23.2c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 v2.1c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V23.2z M193.6,23.3 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M195.9,23.2c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 v2.1c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V23.2z M199,23.3 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M201.3,20.7h0.8l-0.5,2.4h-0.7L201.3,20.7z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M167,34.9h4.1v0.7h-3.3v2.5h2.8v0.7h-2.8V42H167V34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M172.7,40.5l-0.5,1.6h-0.9l2.6-7.1h0.8l2.6,7.1h-0.9l-0.5-1.6H172.7z M174.3,36l-1.3,3.8h2.7L174.3,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M179.2,42h-0.8v-7.1h2.4c0.8,0,1.3,0.1,1.7,0.5c0.4,0.4,0.5,0.8,0.5,1.5c0,1.2-0.5,1.8-1.5,2l1.6,3.2h-0.9 l-1.5-3.1h-1.5V42z M180.8,38.3c0.9,0,1.4-0.4,1.4-1.3c0-0.9-0.5-1.3-1.5-1.3h-1.5v2.7H180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M186.3,37.3h4.4v0.6h-4.4V37.3z M186.3,38.9h4.4v0.6h-4.4V38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M194.9,37.9h0.6c0.8,0,1.3-0.5,1.3-1.2c0-0.8-0.4-1.2-1.1-1.2c-0.6,0-1,0.3-1.1,0.8l-0.7-0.1 c0.1-1,0.8-1.5,1.9-1.5c1.2,0,1.9,0.7,1.9,1.9c0,0.8-0.2,1.2-0.9,1.6c0.8,0.4,1.1,0.9,1.1,1.8c0,1.3-0.7,2-2.1,2 c-1.2,0-1.9-0.5-2-1.5l0.8-0.1c0.1,0.6,0.5,0.9,1.2,0.9c0.8,0,1.3-0.5,1.3-1.4s-0.6-1.5-1.4-1.5h-0.6V37.9z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343,6.4h1.7L347,11l2.2-4.6h1.7V15h-1.8V9.8l-1.6,3.2h-1.2l-1.6-3.2V15H343V6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.8,6.4h5.4v1.5h-3.6v2h3v1.5h-3v2.1h3.6V15h-5.5V6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.7,15h-1.8V6.4h3.2c1.2,0,1.8,0.2,2.2,0.6c0.4,0.4,0.6,1,0.6,1.9c0,1.5-0.4,2.2-1.5,2.5l1.8,3.5h-2l-1.6-3.4h-0.9V15z  M362.9,10.1c0.9,0,1.2-0.3,1.2-1.1c0-0.8-0.3-1.1-1.2-1.1h-1.3v2.3H362.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.7,10.2h3.1v1.5c0,1.3-0.1,1.9-0.6,2.4c-0.6,0.7-1.4,1-2.7,1c-1.3,0-2.1-0.3-2.6-1c-0.4-0.6-0.6-1.2-0.6-2.4V9.8 c0-1.3,0.2-2,0.7-2.6c0.6-0.6,1.3-0.9,2.5-0.9c2,0,3,0.8,3,2.5L371.9,9c-0.1-0.8-0.5-1.2-1.3-1.2c-1,0-1.4,0.5-1.4,2.1v1.6 c0,1.6,0.3,2.1,1.4,2.1c1,0,1.4-0.5,1.4-1.6v-0.5h-1.3V10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5,6.4h5.4v1.5h-3.6v2h3v1.5h-3v2.1h3.6V15h-5.5V6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.4,6.4h3c2.3,0,3.4,1,3.3,3.3v1.9c0.1,2.3-1,3.4-3.3,3.3h-3V6.4z M385.1,13.5c1.4,0,1.8-0.4,1.8-2V9.9 c0-1.6-0.4-2-1.8-2h-0.8v5.6H385.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.9,6.4h1.8v7.1h3.6V15h-5.5V6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.4,9.7c0-1.3,0.2-2,0.7-2.5c0.6-0.6,1.3-0.9,2.5-0.9c1.3,0,2.1,0.3,2.7,1c0.4,0.5,0.6,1.2,0.6,2.4v2 c0,1.3-0.2,2-0.7,2.5c-0.6,0.6-1.3,0.9-2.5,0.9c-1.3,0-2.1-0.3-2.7-1c-0.4-0.5-0.6-1.2-0.6-2.4V9.7z M404,9.8 c0-1.6-0.3-2.1-1.4-2.1c-1.1,0-1.4,0.5-1.4,2.1v1.7c0,1.6,0.3,2.1,1.4,2.1c1.1,0,1.4-0.5,1.4-2.1V9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.2,7.9H407V6.4h6.4v1.5h-2.3V15h-1.8V7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.2,13.4l-0.5,1.6h-2l3.1-8.6h1.8l3.1,8.6h-2l-0.5-1.6H418.2z M419.7,8.6l-1.1,3.3h2.1L419.7,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.7,6.4h3.4c1,0,1.6,0.1,2,0.5c0.5,0.4,0.7,1,0.7,1.8c0,0.8-0.2,1.4-0.7,1.8c0.3,0.3,0.4,0.4,0.5,0.5 c0.2,0.4,0.3,0.9,0.3,1.5c0,0.9-0.3,1.5-0.8,2c-0.4,0.3-0.9,0.4-1.9,0.4h-3.5V6.4z M428,9.9c0.7,0,1-0.3,1-1c0-0.7-0.3-1-1-1h-1.4 v2H428z M428.1,13.5c0.7,0,1-0.3,1-1.1c0-0.8-0.3-1.1-1-1.1h-1.6v2.2H428.1z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M368,21.3h3.2V22h-2.5l-0.2,2.3c0.3-0.2,0.7-0.3,1.1-0.3c0.6,0,1.2,0.3,1.5,0.7c0.3,0.3,0.4,0.8,0.4,1.6 c0,0.7-0.1,1.3-0.5,1.6c-0.4,0.4-1,0.6-1.7,0.6c-1.2,0-1.8-0.5-2-1.5l0.8-0.1c0.1,0.6,0.5,0.9,1.2,0.9c0.8,0,1.3-0.5,1.3-1.5 c0-1.1-0.4-1.6-1.2-1.6c-0.4,0-0.8,0.1-1.1,0.4l-0.6-0.1L368,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M372.9,23.8c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 v2.1c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V23.8z M376,23.9 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M378.3,21.3h0.8l-0.5,2.4h-0.7L378.3,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M381.8,23.4h0.9l1.1,1.8l1.1-1.8h0.9l-1.6,2.5l1.6,2.5h-0.9l-1.2-1.9l-1.2,1.9h-0.9l1.6-2.6L381.8,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M390.5,22.2l-1.2,0.5L389,22l1.7-0.8h0.6v7.1h-0.8V22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M394.2,23.8c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 v2.1c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V23.8z M397.4,23.9 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M399.6,23.8c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 v2.1c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V23.8z M402.8,23.9 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M405,21.3h0.8l-0.5,2.4h-0.7L405,21.3z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M371,35.5h4.1v0.7h-3.3v2.5h2.8v0.7h-2.8v3.2H371V35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M376.7,41.1l-0.5,1.6h-0.9l2.6-7.1h0.8l2.6,7.1h-0.9l-0.5-1.6H376.7z M378.3,36.6l-1.3,3.8h2.7L378.3,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M383.2,42.6h-0.8v-7.1h2.4c0.8,0,1.3,0.1,1.7,0.5c0.4,0.4,0.5,0.8,0.5,1.5c0,1.2-0.5,1.8-1.5,2l1.6,3.2h-0.9 l-1.5-3.1h-1.5V42.6z M384.8,38.9c0.9,0,1.4-0.4,1.4-1.3c0-0.9-0.5-1.3-1.5-1.3h-1.5v2.7H384.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M390.2,37.9h4.4v0.6h-4.4V37.9z M390.2,39.5h4.4v0.6h-4.4V39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M398.8,38.5h0.6c0.8,0,1.3-0.5,1.3-1.2c0-0.8-0.4-1.2-1.1-1.2c-0.6,0-1,0.3-1.1,0.8l-0.7-0.1 c0.1-1,0.8-1.5,1.9-1.5c1.2,0,1.9,0.7,1.9,1.9c0,0.8-0.2,1.2-0.9,1.6c0.8,0.4,1.1,0.9,1.1,1.8c0,1.3-0.7,2-2.1,2 c-1.2,0-1.9-0.5-2-1.5l0.8-0.1c0.1,0.6,0.5,0.9,1.2,0.9c0.8,0,1.3-0.5,1.3-1.4s-0.6-1.5-1.4-1.5h-0.6V38.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotMerger);
export default __webpack_public_path__ + "static/media/lot_merger.0c686de2821a8f92c24923792ea9bf2f.svg";
export { ForwardRef as ReactComponent };